export var ComponentType;
(function (ComponentType) {
    ComponentType["Dropdown"] = "Dropdown";
    ComponentType["FacesRatingBar"] = "FacesRatingBar";
    ComponentType["TextInput"] = "TextInput";
    ComponentType["SegmentedToggle"] = "SegmentedToggle";
})(ComponentType || (ComponentType = {}));
//# sourceMappingURL=types.js.map